import React from 'react';
import { Trophy, Star, ShieldCheck, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-bb-light to-bb-cream overflow-hidden pt-5 pb-10 sm:pt-10 sm:pb-16 px-4 sm:px-6 lg:px-8" data-id="element-126">
      {/* Court line texture overlay */}
      <div className="absolute inset-0 court-lines pointer-events-none opacity-60" data-id="element-127"></div>
      {/* Decorative orange glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-bb-orange/20 rounded-full blur-3xl pointer-events-none" data-id="element-128"></div>
      <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-bb-charcoal/10 rounded-full blur-3xl pointer-events-none" data-id="element-129"></div>

      <div className="relative max-w-3xl mx-auto flex flex-col items-center text-center z-10" data-id="element-130">
        <div className="flex items-center gap-2 mb-3 sm:mb-6" data-id="element-131">
          <span className="text-xl sm:text-2xl" data-id="element-132">🏀</span>
          <span className="font-display font-semibold text-bb-charcoal text-base sm:text-lg tracking-[0.25em] uppercase" data-id="element-133">
            The Coach's Bible
          </span>
        </div>

        <div className="bg-bb-orange/10 backdrop-blur-sm border border-bb-orange/30 text-bb-orange-dark font-bold text-[10px] sm:text-xs px-3 sm:px-4 py-1.5 rounded-full mb-4 sm:mb-8 inline-flex items-center gap-2 shadow-sm uppercase tracking-[0.18em]" data-id="element-134">
          <Trophy className="w-3.5 h-3.5" data-id="element-135" /> Pro-Level Coaching Methodology
        </div>

        <h1 className="font-display font-bold uppercase text-bb-charcoal leading-[1.05] mb-4 sm:mb-6 tracking-tight text-[32px] sm:text-5xl md:text-6xl" data-id="element-136">
          The Complete <span className="text-bb-orange" data-id="element-137">365-Day</span> Strategic
          Roadmap for Basketball Coaches
        </h1>

        <p className="text-sm sm:text-lg text-bb-slate max-w-xl mb-5 sm:mb-10 leading-relaxed px-2 sm:px-0" data-id="element-138">
          Save hours of prep time, regain your peace of mind, and elevate your
          team's performance — without the burnout of manual planning.
        </p>

        <div className="mb-5 sm:mb-10 max-w-[260px] sm:max-w-md mx-auto w-full" data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/dWteTQevNEHvKbLzQXkEmc/heylloyd-image-1780160765114.webp" alt="The Basketball Coach's Bible — 6-Books-in-1 Box Set" className="w-full rounded-2xl shadow-2xl" fetchPriority="high" decoding="async" width="800" height="800" data-id="element-140" />
        </div>

        <a href="#pricing-card" className="group relative inline-flex items-center justify-center gap-2 sm:gap-3 bg-bb-orange hover:bg-bb-orange-dark text-white font-bold text-sm sm:text-lg uppercase tracking-wide py-4 sm:py-5 px-6 sm:px-12 rounded-full shadow-[0_10px_30px_rgba(234,88,12,0.4)] hover:shadow-[0_15px_40px_rgba(234,88,12,0.55)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-141">
          <span data-id="element-142">🏀 I Want the System Now</span>
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-143" />
        </a>

        <div className="mt-4 sm:mt-6 flex flex-col items-center gap-1.5 sm:gap-2" data-id="element-144">
          <div className="flex items-center gap-2" data-id="element-145">
            <div className="flex text-bb-orange" data-id="element-146">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="currentColor" data-id="element-147" />)}
            </div>
            <span className="text-bb-slate text-xs sm:text-sm font-medium" data-id="element-148">
              4.9/5 — Verified Reviews
            </span>
          </div>
          <div className="flex items-center gap-2 text-bb-slate text-xs sm:text-sm" data-id="element-149">
            <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-bb-orange" data-id="element-150" />
            <span data-id="element-151">30-Day Money-Back Guarantee — ZERO Risk</span>
          </div>
        </div>
      </div>
    </section>;
}